import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import styles from './displayBoxLabel.scss';

class DisplayBoxLabel extends PureComponent {
  getDisplayBoxLabelClassNames() {
    return classNames({
      [styles.labelContainer]: true,
      [themeStyles.categoryLabel]: true,
      [this.props.className]: this.props.className,
    });
  }

  render() {
    const { text, textColor, backgroundColor } = this.props;
    return (
      <div
        className={this.getDisplayBoxLabelClassNames()}
        style={{
          color: `${textColor}`,
          backgroundColor: `${backgroundColor}`,
        }}
      >
        {text}
      </div>
    );
  }
}

DisplayBoxLabel.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
};

export default DisplayBoxLabel;
